var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 140,
    viewBox: "0 0 140 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "currentColor",
    d: "M102.89 39.3113L87.1431 23.2858C85.4538 21.5667 83.164 20.5926 80.7803 20.5926H42.4721C37.4983 20.6117 33.4629 24.7183 33.4629 29.78V109.239C33.4629 114.301 37.4983 118.407 42.4721 118.407H96.5277C101.502 118.407 105.537 114.301 105.537 109.239V45.8055C105.537 43.3798 104.58 41.0304 102.89 39.3113ZM98.6486 43.6472C99.0428 44.0483 99.3056 44.5258 99.4369 45.0606H81.5123V26.8194C82.0378 26.9531 82.507 27.2205 82.9012 27.6217L98.6486 43.6472ZM96.5277 112.295H42.4721C40.8205 112.295 39.4691 110.92 39.4691 109.239V29.78C39.4691 28.0992 40.8205 26.7239 42.4721 26.7239H75.5061V46.5887C75.5061 49.1291 77.5144 51.1729 80.0107 51.1729H99.5308V109.239C99.5308 110.92 98.1794 112.295 96.5277 112.295ZM87.5184 68.2635V69.7915C87.5184 71.0522 86.5049 72.0836 85.2661 72.0836H53.7337C52.4949 72.0836 51.4814 71.0522 51.4814 69.7915V68.2635C51.4814 67.0028 52.4949 65.9714 53.7337 65.9714H85.2661C86.5049 65.9714 87.5184 67.0028 87.5184 68.2635ZM87.5184 87.5643V89.0923C87.5184 90.353 86.5049 91.3844 85.2661 91.3844H53.7337C52.4949 91.3844 51.4814 90.353 51.4814 89.0923V87.5643C51.4814 86.3036 52.4949 85.2722 53.7337 85.2722H85.2661C86.5049 85.2722 87.5184 86.3036 87.5184 87.5643Z",
    strokeWidth: 3.08889
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileIcon);
export default __webpack_public_path__ + "static/media/FileIcon.ad7122ea10d1c42eff0e26ee93f43593.svg";
export { ForwardRef as ReactComponent };